import { Container } from "reactstrap";
import classes from "./styles.module.scss";

const FEATURES = [
  "Development Testing for New and Existing Products",
  "Consecutive Impact Testing",
  "Enhanced Impact Scans",
  "Simulated Hail Storm Testing",
];

const ManufacturerTesting = () => {
  const handleContactUs = () => {
    window.location.href = "mailto:office@unit5testing.com";
  };

  return (
    <div id="unit5-manufacturer-testing" className={classes.wrapper}>
      <Container className={classes.container}>
        <h2 className={classes.title}>Manufacturer Development Testing</h2>
        <div className={classes.featuresRow}>
          {FEATURES.map((feature, index) => (
            <div key={index} className={classes.featureCard}>
              <span className={classes.featureText}>{feature}</span>
            </div>
          ))}
        </div>
        <div className={classes.buttonWrapper}>
          <button className={classes.contactButton} onClick={handleContactUs}>
            <span className={classes.buttonText}>Contact Us</span>
          </button>
        </div>
      </Container>
    </div>
  );
};

export default ManufacturerTesting;
